import React from "react"
import autobind from "class-autobind"
import { IconButton, FontIcon, IconMenu, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import AppStateStore from "../../../stores/AppStateStore"
import { IDate, IPayrollPayGroupData, IUserDocument, ICustomReportDocument, ECustomReportLocation, INewCustomReportParameters } from "../../../models"
import EmployeeTimecardDefaultReport from "./EmployeeTimecardDefaultReport"
import * as api from "../../../api"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import { hasPermission } from "../../../helpers/permissionHelper"
import AuthenticationStore from "../../../stores/AuthenticationStore"

interface IProps {
    user: IUserDocument
    payrollPayGroupData: IPayrollPayGroupData
    referenceDate: IDate
}
interface IState {
    openDefaultReportDialog: boolean
    newReports: ICustomReportDocument[]
}

export default class EmployeeTimecardReport extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openDefaultReportDialog: false,
            newReports: []
        }
        autobind(this)
    }

    componentDidMount() {
        this.getNewReportTypes()
    }

    getNewReportTypes() {
        api.getCustomReportTypes(ECustomReportLocation.EmployeeTimecardTab).then(res =>
            this.setState({ newReports: res.data })
        )
    }

    render() {
        return (
            <div>
                {hasPermission(AuthenticationStore.Permissions.Account.ViewTimeReports) &&<IconMenu
                    iconButtonElement={
                        <IconButton data-intercom-target={"Employee-Timecard-Select-Report"} tooltip={strings.Reports}>
                            <FontIcon className="fa fa-file-text" style={{ fontSize: 20 }} />
                        </IconButton>
                    }
                >
                   <MenuItem data-intercom-target={"Employee-Timecard-Reports-Btn-DefaultReportDialog"} primaryText={strings.Employee_Timecard_Report} leftIcon={<FontIcon className="fa fa-file-excel-o" />} onTouchTap={() => this.setState({ openDefaultReportDialog: true })} />
                    {this.state.newReports.map(i =>
                        <MenuItem
                            key={i.Id}
                            data-intercom-target={"Timecards-Reports-Btn-OpenNewReport"}
                            primaryText={i.Name}
                            leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                            onTouchTap={() => AppStateStore.setNewCustomReportDialogContent({
                                newCustomReportDoc: i,
                                newCustomReportParameters: {
                                    Id: this.props.user.Id,
                                    Date1: this.props.referenceDate,
                                    UserPayGroupId: payGroupAndTypeHelper.getPayGroupIdByPayrollPayGroupData(this.props.payrollPayGroupData)
                                } as INewCustomReportParameters
                            })}
                        />
                    )}
                </IconMenu>}
                {/* <IconButton
                    data-intercom-target={"Employee-Timecard-Report"}
                    iconStyle={{ color: "#777777", fontSize: 20 }}
                    style={{ heiht: 36, width: 36, padding: 13 }}
                    onClick={this.handleDialog}
                >
                    <FontIcon className="fa fa-file-text" />
                </IconButton> */}
                {this.state.openDefaultReportDialog &&
                    <EmployeeTimecardDefaultReport
                        userId={this.props.user.Id}
                        payrollPayGroupData={this.props.payrollPayGroupData}
                        referenceDate={this.props.referenceDate}
                        handleClose={() => this.setState({ openDefaultReportDialog: false })}
                    />
                }
            </div>
        )
    }
}